import { BaseContainerModel } from '../../base-container.model';
import { bl_crm_pricing_scheme_item_point_link_RowClass } from '../../../dbschema/bl_crm_pricing_scheme_item_point_link.model';

export class ItemPointLinkContainerModel extends BaseContainerModel {
  bl_crm_pricing_scheme_item_point_link: bl_crm_pricing_scheme_item_point_link_RowClass = new bl_crm_pricing_scheme_item_point_link_RowClass();

}
